import React from "react";
import FullPageLoaderSvg from "../../assets/NoDataSvg/FullPageLoaderSvg";

const VmoFullPageLoader = () => {
  return (
    <div className="scene">
      <FullPageLoaderSvg />

      <div id="progress-bar-container">
        <div className="progress-bar-child progress"></div>
        <div className="progress-bar-child shrinker timelapse"></div>
      </div>
    </div>
  );
};

export default VmoFullPageLoader;
